import React, { ReactElement } from 'react'
import {
  isFeatureEnabledForLanguage,
  useAgentFeatures
} from '../agent-features'
import { AgentLanguage } from '../agent-language'
import { useApplication } from '../application/api/use-application'
import { Application } from '../application/api/requests/get-application'

interface Props {
  organizationUuid: string
  applicationId: string
  children: (props: {
    application: Application
    isFeatureEnabledForProtect: boolean
    isFeatureEnabledForAssess: boolean
  }) => ReactElement
}

export function ExclusionWrapper({
  applicationId,
  organizationUuid,
  children
}: Props) {
  const {
    isLoading: agentFeaturesLoading,
    data: agentFeatures,
    error: agentFeaturesError
  } = useAgentFeatures()

  const {
    isLoading: isAppLoading,
    error: appError,
    data: application
  } = useApplication(organizationUuid, applicationId)

  if (agentFeaturesError) {
    throw new Error('Failed getting agent features data')
  }
  if (appError) {
    throw new Error('Failed getting application data')
  }

  if (isAppLoading || !application || agentFeaturesLoading || !agentFeatures) {
    return <></>
  }

  const isFeatureEnabledForAssess = isFeatureEnabledForLanguage({
    agentFeatures,
    featureName: 'app-assessment-exclusions',
    language: AgentLanguage.fromValue(application.language)
  })
  const isFeatureEnabledForProtect = isFeatureEnabledForLanguage({
    agentFeatures,
    featureName: 'app-protection-exclusions',
    language: AgentLanguage.fromValue(application.language)
  })

  return children({
    application,
    isFeatureEnabledForAssess,
    isFeatureEnabledForProtect
  })
}
